import React from 'react';
import AKSearchIcon from '@atlaskit/icon/core/search';
import { token } from '@atlaskit/tokens';
import { N800 } from '@atlaskit/theme/colors';

import type { SearchCSS } from '../theme';

interface Props {
	isExpanded: boolean;
	theme: SearchCSS;
	primaryColor?: string;
	label?: string;
}

export const SearchIcon = ({
	isExpanded,
	theme,
	primaryColor = token('color.text', N800),
	label = '',
}: Props): React.JSX.Element => (
	<AKSearchIcon
		label={label}
		// NOTE: color do not accept string type but here primaryColor is string, so need to use any
		color={isExpanded ? (primaryColor as any) : theme.default.color}
	/>
);
